<template>
  <Modal v-if="props.member" v-model="showModal" :header="false" data-test="etl-modal">
    <h2 v-if="error" data-test="etl-error">
      Oops, there was an error editing this member's role.
    </h2>
    <div v-else>
      <h2 data-test="etl-message">
        Are you sure you want to {{ isAddingRole ? "add" : "remove" }} {{ memberFullName }} as a
        team lead?
      </h2>
    </div>
    <template #footer>
      <div class="controls">
        <button class="btn btn-primary" @click="closeRoleModal" data-test="etl-close" type="button">
          Cancel
        </button>
        <button
          class="btn btn-default"
          @click="confirmRole()"
          data-test="etl-confirm"
          type="button"
        >
          Confirm
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Modal } from "uiv";
import { TeamCurrentMemberApiModel } from "../../../api-models";

const props = defineProps<{
  member: TeamCurrentMemberApiModel;
  showRoleModal: boolean;
  error: boolean;
  isAddingRole: boolean | null;
}>();

const emit = defineEmits(["close-role-modal", "confirm-role"]);

const memberFullName = computed(() => {
  if (!props.member) return "";
  return `${props.member.userDetails.firstName} ${props.member.userDetails.lastName}`;
});

const showModal = computed(() => {
  return props.showRoleModal;
});

const closeRoleModal = (): void => {
  emit("close-role-modal");
};

const confirmRole = (): void => {
  if (!props.member) return;
  // Always pass "admin" role when confirming
  emit("confirm-role", props.member, "admin");
};
</script> 